import { FunctionComponent, useCallback, useState } from "react";
import { useAppDispatch, useAppSelector } from "@store/store";
import { useTranslation } from "react-i18next";
import {
  selectAuthFlow,
  selectEmail,
  setAuthViewAction,
} from "@store/sessionReducer";
import { FormStatus } from "../../../../components/formFields/FormStatus";
import { AuthLinkButton } from "../../components/AuthLinkButton/AuthLinkButton";
import { AuthInstructions } from "../../components/AuthInstructions/AuthInstructions";
import { AuthError } from "../../components/AuthError/AuthError";
import { resendMagicLinkAction } from "@store/auth/actions/resendMagicLinkAction";
interface MagicLinkSentProps {}

const MagicLinkSent: FunctionComponent<MagicLinkSentProps> = () => {
  const [state, setState] = useState<{ status: FormStatus }>({
    status: "idle",
  });
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const email = useAppSelector(selectEmail);
  const authFlow = useAppSelector(selectAuthFlow);

  const handleResendLink = useCallback(async () => {
    setState({ status: "fetching" });
    try {
      await dispatch(resendMagicLinkAction({ email }));
      setState({ status: "idle" });
    } catch (_error) {
      setState({ status: "error" });
    }
  }, [dispatch, email]);

  const handleUsePassword = useCallback(() => {
    dispatch(setAuthViewAction({ authView: "signInPassword" }));
  }, [dispatch]);

  const handleGoBack = useCallback(() => {
    dispatch(setAuthViewAction({ authView: "signInEmail" }));
  }, [dispatch]);

  const disabled = state.status === "fetching" || state.status === "success";

  return (
    <>
      <AuthInstructions />
      <div className="form-container">
        <div className="form-button-container">
          <AuthLinkButton
            label={t("screens.auth.magicLinkSent.resendLink")}
            onPress={handleResendLink}
            disabled={disabled}
          />
          {authFlow === "signIn" && (
            <>
              <AuthLinkButton
                label={t("screens.auth.magicLinkSent.usePassword")}
                onPress={handleUsePassword}
              />
              <AuthLinkButton
                label={t("common.goBack")}
                onPress={handleGoBack}
                disabled={disabled}
              />
            </>
          )}
        </div>
      </div>

      {state.status === "error" && <AuthError />}
    </>
  );
};

export { MagicLinkSent };
